export default __webpack_public_path__ + "static/media/wallpaper.2b198f55.jpeg";